import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollProvider } from "./components/organisms/Scrollprovider";

import Navbar from "./components/molecules/Navbar";
import Footer from "./components/molecules/Footer";
import Home from "./components/organisms/Home";
import NuestraPlataforma from "./components/organisms/NuestraPlataforma";
import NuestrosPlanes from "./components/organisms/NuestrosPlanes";
import QueHacemos from "./components/organisms/QueHacemos";
import SubscriptionDetail from "./components/organisms/SubscriptionDetail";
import PromotionPopUp from "./components/molecules/PromotionPopUp";

function App() {

  const [isPromotionVisible, setIsPromotionVisible] = useState(true);
  const handleHidePopup = () => {
    setIsPromotionVisible(false);
  };

  const showPromotionPopup = false;

  return (
    <ScrollProvider>
      <BrowserRouter>
        <div className="App">
          {showPromotionPopup && isPromotionVisible && <PromotionPopUp onClose={handleHidePopup} />}

          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/NuestraPlataforma" element={<NuestraPlataforma />} />
            <Route path="/NuestrosPlanes" element={<NuestrosPlanes />} />
            <Route path="/QueHacemos" element={<QueHacemos />} />
            <Route path="/subscription/:id" element={<SubscriptionDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </ScrollProvider>
  );
}

export default App;
